import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';
import { buildOnThisPageNav } from './build-on-this-page-nav';

const gc = new DisposalSet();

registerFragment('chroa-resource-body-minimal', (fragmentElement, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}

document.addEventListener('DOMContentLoaded', () => {

    // Build nav (will trigger event if nav is built)
    const navBuilt = buildOnThisPageNav();

});
